/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import type { TermsCategoryValue } from '@hems/util/src/constant/terms';

import type { CommonResponseWrapper } from 'hems';

import type { TermsInfo, EffectiveTermsInfo } from 'hems/terms';

export default class TermsService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 현재 유효 약관 조회 */
  getTerms = async (termsType: string): Promise<EffectiveTermsInfo[]> => {
    const { data } = await this.get<CommonResponseWrapper<EffectiveTermsInfo[]>>(
      apiWrapper.managerApi('/managements/mobiles/pro-apps/terms'),
      { termsType }
    );

    return data;
  };

  /** 약관 목록 조회 */
  getTermsList = async (category: TermsCategoryValue): Promise<TermsInfo[]> => {
    const { data } = await this.get<CommonResponseWrapper<TermsInfo[]>>(
      apiWrapper.managerApi('/managements/terms/list'),
      {
        categoryNm: category,
      }
    );

    return data;
  };

  /** 약관 상세 조회 */
  getTermsDetail = async (termsId: number): Promise<TermsInfo> => {
    const { data } = await this.get<CommonResponseWrapper<TermsInfo>>(apiWrapper.managerApi('/managements/terms'), {
      termsId,
    });

    return data;
  };

  /** 약관 생성 */
  registerTerms = async (termsInfo: Partial<TermsInfo>) => {
    const { data } = await this.post<CommonResponseWrapper<any>>(
      apiWrapper.managerApi('/managements/terms'),
      termsInfo
    );

    return data;
  };

  /** 약관 수정 */
  updateTerms = async (termsId: number, termsInfo: Partial<TermsInfo>) => {
    const { data } = await this.post<CommonResponseWrapper<any>>(apiWrapper.managerApi('/managements/terms/update'), {
      termsId,
      ...termsInfo,
    });

    return data;
  };

  /** 약관 삭제 */
  deleteTerms = async (termsId: number) => {
    const { data } = await this.delete<CommonResponseWrapper<any>>(
      apiWrapper.managerApi('/managements/terms/delete'),
      undefined,
      {
        data: {
          termsId,
        },
      }
    );

    return data;
  };
}
